// @ts-nocheck
import loadCarts from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCarts";
import { chain, LoadCart, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";
import { getSavedCartsApiParameter } from "@store/Framework/Store/Store/Components/SaveCart/Handlers/SwapCart";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            properties: {
                ...props.apiParameter.cart.properties,
                cartLabel: props.getState().store.components.saveCart.cartLabel,
            },
        },
    };
});

addToChainAfter(chain, LoadCart, props => {
    props.dispatch(
        loadCarts({
            apiParameter: {
                ...getSavedCartsApiParameter,
                additionalQueryStringParameters: {
                    forceRecalculation: `${Date.now()}`,
                },
            },
        }),
    );
});
